export const folderImg = "https://d338t8kmirgyke.cloudfront.net/icons/icon_pngs/000/002/204/original/folder.png";
export const fileImg = "https://i.pinimg.com/originals/8b/aa/11/8baa11ae5d5c81b6eaa4f832c211a763.jpg"